<ion-content class="ion-padding">
  <ion-refresher slot="fixed" (ionRefresh)="carregarDocumentos($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <usucampeao-proprietarios-documentos-selecionar-tipo [tipo]="tipo" [estadoCivilProprietario]="(proprietarioEstadoCivil$ | async)" [documentos]="documentos$ | async"></usucampeao-proprietarios-documentos-selecionar-tipo>
</ion-content>
